import { useCallback } from 'react';
import { Box, SimpleGrid, Stack } from '@mantine/core';

import { Button, Textarea } from 'components';
import { CreditRequestStep } from 'types';
import { AppConstants } from '../../../../constants';
import CreditRequestEmployment from './income/employment';
import CreditRequestIncome from './income/income';

const { CREDIT_REQUEST_FORM_PADDING } = AppConstants;

const IncomeInformationStep = ({
  form,
  isEditable,
  onSubmit,
  options,
  t,
}: CreditRequestStep) => {

  const onSubmitWrapper = useCallback(() => {
    if (isEditable && !isFormValid()) {
      return;
    }
    onSubmit();
  }, [isEditable, form.values, options]);

  const isFormValid = useCallback(() => {
    let isValid = true;
    return isValid;
  }, [form.values, options]);

  return (
    <SimpleGrid cols={{ base: 1, md: 2 }}>
      <Stack p={CREDIT_REQUEST_FORM_PADDING}>
        <CreditRequestEmployment form={form} options={options} t={t} partner={false} disabled={!isEditable} />
        <CreditRequestIncome form={form} options={options} t={t} partner={false} disabled={!isEditable} />
      </Stack>
      <Stack p={CREDIT_REQUEST_FORM_PADDING}>
        {form.values.partnerIncludeInApplication ? 
          <>
            <CreditRequestEmployment form={form} options={options} t={t} partner={true} disabled={!isEditable} />
            <CreditRequestIncome form={form} options={options} t={t} partner={true} disabled={!isEditable} />
          </>
        : undefined}
        <Textarea
          label={t('input.comment.label')}
          key={form.key('comment3')}
          {...form.getInputProps('comment3')}
          info={t('input.comment.info.message')}
          disabled={!isEditable}
        />
        <Button onClick={onSubmitWrapper}>
          {t('action.next')}
        </Button>
      </Stack>
    </SimpleGrid>
  )
}

export default IncomeInformationStep;